<template>
    <modal
        :title="$t('Filters')"
        :id="id"
        dialog-class="modal-dialog-vertical"
    >
        <div class="row filter-vertical-modal">
            <slot></slot>
        </div>
        <template slot="modal-footer" slot-scope="{close}">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col">
                    </div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="btn btn-white">{{ $t('Close') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
    props: ['id', 'title'],
    components: {
        Modal
    },
    data() {
        return {
        }
    },
    methods: {
        close() {
            this.$root.$emit('bv::hide::modal', this.id)
        }
    }
}
</script>

<style lang="scss">
.filter-vertical-modal {
    .btn-group[role="group"] {
        min-width: 300px;
    }
    .dropdown.b-dropdown.btn-group {
        flex-grow: 100;
    }
    button.btn.dropdown-toggle {
        justify-content: space-between;
        display: flex;
        overflow: hidden;
        width: 261px;
    }
    ul.dropdown-menu {
        width: 300px;
    }
    .dropdown1 {
        overflow: hidden;
        max-width: 313px;
        border-right: 1px solid #e3ebf6;
        border-bottom-right-radius: 0.375rem;
        border-top-right-radius: 0.375rem;
    }
}
</style>
